module.exports = __webpack_public_path__ + "assets/expressionengine.65167f3b.svg";